import { render, staticRenderFns } from "./DialogBaseColoredTitle.vue?vue&type=template&id=714cc995&scoped=true&"
import script from "./DialogBaseColoredTitle.vue?vue&type=script&lang=js&"
export * from "./DialogBaseColoredTitle.vue?vue&type=script&lang=js&"
import style0 from "./DialogBaseColoredTitle.vue?vue&type=style&index=0&id=714cc995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714cc995",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VSpacer,VToolbar,VToolbarTitle})
